import { render } from "./SpecificationField.vue?vue&type=template&id=a8918aca&scoped=true"
import script from "./SpecificationField.vue?vue&type=script&lang=js"
export * from "./SpecificationField.vue?vue&type=script&lang=js"

import "./SpecificationField.vue?vue&type=style&index=0&id=a8918aca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8918aca"]])

export default __exports__